import { IconType } from "react-icons/lib";

export interface Price {
  value: number;
  text: string;
}

export interface AddressSuggestion {
  placeId: string;
  displayName: string;
}

export interface NavOption {
  label: string;
  icon: IconType;
}

export interface DropdownOption {
  label: string;
  value: string;
}

export enum OrderType {
  PICKUP = "pickup",
  DELIVERY = "delivery",
}

export interface PaginationQuery {
  page?: number;
  perPage?: number;
}

export interface PaginationInfo extends Required<PaginationQuery> {
  count: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  paginationInfo: PaginationInfo;
}
